module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Sala-4-zoom.653e7ead.png";